module.exports = __webpack_public_path__ + "img/80ru.f1d91934.png";